



















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Tooltip from '@/components/UI/Tooltip.vue';
import IQuestion from "@/components/icons/IQuestion.vue";

@Component({
  name: "ChangeClicker",
  components: {
    IQuestion,
    Tooltip
  }
})
export default class ChangeClicker extends Vue {
  @Prop({type: Array, default: []}) items!: any
  @Prop({type: Array, default: () => []}) disabled!: any
  @Prop({type: Number, default: 0}) answersSum!: any
  @Prop({type: String, default: ''}) answersSumHelper!: any
  @Prop({type: String, default: null}) defaultSelect!: any
  @Prop({type: String, default: 'start'}) alignClicker!: any

  mounted() {
    let ind;
    if (this.defaultSelect) {
      switch (this.defaultSelect) {
        case 'bar':
          ind = 0
          break;
        case 'column':
          ind = 1
          break;
        case 'pie':
          ind = 2
          break;
      }
      this.changeColor(ind)
      this.$emit('ChangeClick', this.defaultSelect)
    }

  }

  icon = [
    {
      background: '#2D9CDB',
      color: 'white'
    },
    {
      background: 'white',
      color: 'black'
    },
    {
      background: 'white',
      color: 'black'
    }
  ]

  changeColor(index: any) {
    this.icon[index].color = 'white'
    this.icon[index].background = '#2D9CDB'

    this.icon.map((ele: any, ind: number) => {
      if (ind !== index) {
        ele.color = 'black'
        ele.background = 'white'
      }
    })

  }

  clickIcon(iconName: string, iconIndex: number) {
    if (this.disabled.includes(iconName)) return
    this.$emit('ChangeClick', iconName)
    this.changeColor(iconIndex)
  }

}
